import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="lrk-picker"
// Searches LRK locations for the new organization form and keeps the chosen
// ones as chips. The chosen LRK numbers go to the server in one hidden field,
// so the organization is created exactly as if they had been typed in.
export default class extends Controller {
  static targets = ["query", "results", "numbers", "chips", "chip", "section", "klasse"];
  static values = { url: String };

  connect() {
    this.timeout = null;
    this.toggleSection();
  }

  disconnect() {
    clearTimeout(this.timeout);
  }

  search() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.load(), 250);
  }

  klasseChanged() {
    this.toggleSection();
    if (this.isLrk()) {
      this.load();
    } else {
      this.chipTargets.forEach((chip) => chip.remove());
      this.writeNumbers();
    }
  }

  add(event) {
    const { lrkId, label } = event.currentTarget.dataset;
    if (!this.numbers().includes(lrkId)) {
      this.chipsTarget.append(this.buildChip(lrkId, label));
      this.writeNumbers();
    }
    this.queryTarget.value = "";
    this.load();
    this.queryTarget.focus();
  }

  // Enter in the search box would otherwise submit the whole form
  ignoreEnter(event) {
    event.preventDefault();
  }

  remove(event) {
    event.currentTarget.closest("[data-lrk-picker-target='chip']").remove();
    this.writeNumbers();
  }

  // private

  load() {
    const query = this.queryTarget.value.trim();
    if (query.length < 2) {
      this.resultsTarget.removeAttribute("src");
      this.resultsTarget.innerHTML = "";
      return;
    }

    const url = new URL(this.urlValue, window.location.origin);
    url.searchParams.set("q", query);
    url.searchParams.set("klasse", this.klasseTarget.value);
    this.resultsTarget.src = url.toString();
  }

  isLrk() {
    return this.klasseTarget.value !== "non_lrk";
  }

  toggleSection() {
    this.sectionTarget.classList.toggle("hidden", !this.isLrk());
  }

  numbers() {
    return this.chipTargets.map((chip) => chip.dataset.lrkId);
  }

  writeNumbers() {
    this.numbersTarget.value = this.numbers().join(",");
  }

  // Same markup as the chips the form renders for numbers already chosen
  buildChip(lrkId, label) {
    const chip = document.createElement("span");
    chip.className = "badge badge-primary gap-2 py-3";
    chip.dataset.lrkPickerTarget = "chip";
    chip.dataset.lrkId = lrkId;

    const text = document.createElement("span");
    text.textContent = label;

    const button = document.createElement("button");
    button.type = "button";
    button.textContent = "×";
    button.setAttribute("aria-label", this.element.dataset.lrkPickerRemoveLabel);
    button.dataset.action = "lrk-picker#remove";

    chip.append(text, button);
    return chip;
  }
}
